export default __webpack_public_path__ + "static/media/Eye_1_M_C4.76b0c84f.svg";